export const getFormJourneyConfig = ({
  isFormu2,
  portalJourneyEnabled,
}) => {
  const isPortalJourney = Boolean(isFormu2 && portalJourneyEnabled);
  return {
    isPortalJourney,
    summaryStep: isPortalJourney ? 8 : isFormu2 ? 10 : 8,
    finalizeStep: isPortalJourney ? 7 : isFormu2 ? 9 : 7,
    useLegacyAudioSteps: Boolean(isFormu2 && !isPortalJourney),
    offerSaveForLaterPassword: Boolean(isFormu2 && !isPortalJourney),
  };
};
